import { TileLayer } from "@deck.gl/geo-layers";
import { BitmapLayer } from "@deck.gl/layers";

import { MAP_TILER_API_KEY } from "../main-map";

import { BackgroundMap } from "./use-background-picker";

// This only renders the background not the labels that happens in the mapstyle
const useBackgroundLayer = (backgroundMap: BackgroundMap): TileLayer => {
  const backgroundTileLayerUrl = (() => {
    if (backgroundMap === "satellite") {
      return `https://api.maptiler.com/maps/b74dd3c4-d3c4-4a54-9fdf-53d4e8d6b9f6/{z}/{x}/{y}.webp?key=${MAP_TILER_API_KEY}`;
    }
    if (backgroundMap === "dark") {
      return `https://api.maptiler.com/maps/403d0683-14b4-4f19-964d-6bc106b2b303/{z}/{x}/{y}.webp?key=${MAP_TILER_API_KEY}`;
    }
    // Topographic
    return `https://api.maptiler.com/maps/09eabd5c-f052-443e-9b67-a3a3a579d40b/{z}/{x}/{y}.webp?key=${MAP_TILER_API_KEY}`;
  })();

  return new TileLayer({
    id: "tile-background-layer",
    data: backgroundTileLayerUrl,

    renderSubLayers: (props) => {
      const {
        bbox: { west, south, east, north },
      } = props.tile as any; // eslint-disable-line @typescript-eslint/no-explicit-any

      return new BitmapLayer(props, {
        data: undefined,
        image: props.data,
        bounds: [west, south, east, north],
      });
    },
  });
};

export { useBackgroundLayer };
